module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja-jp":{"locale":"ja-jp"},"en-us":{"locale":"en-us"},"en-gb":{"locale":"en-gb"},"de-de":{"locale":"de-de"},"fr-fr":{"locale":"fr-fr"},"fr-ca":{"locale":"fr-ca"},"es-es":{"locale":"es-es"},"it-it":{"locale":"it-it"},"es-mx":{"locale":"es-mx"},"pt-br":{"locale":"pt-br"},"zh-tw":{"locale":"zh-tw"}}')
  delete Component.options._Ctor
}
